"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _table, _table2;
var _default = exports.default = {
  route: {
    sfe: 'SFE',
    noticemodule: '公告管理模块',
    notice: '公告管理',
    noticecontent: '公告内容详情',
    configuration: '配置管理',
    district: '省市区管理',
    account: '用户管理',
    messagepush: '消息推送管理',
    sfeloginlog: '登录日志管理',
    organizationarchitecture: '业务组织架构管理',
    salesarea: '销售区域管理',
    productmodule: '产品管理模块',
    material: '产品管理',
    materialdetails: '产品详情',
    storedetails: '门店详情',
    contractkpimanagement: '签约KPI管理',
    saleskpimanagement: '销量KPI管理',
    reportmodule: '固特异报表',
    monthkpi: '月度KPI报表',
    quarterkpi: '季度KPI报表',
    ordersbymonth: '月度订单情况',
    srstoreorderdetaillist: '零售店销量明细',
    carpac: 'CARPARC',
    orderrecommended: '订单推荐明细',
    storedetaillist: '门店明细',
    appversion: 'APP版本管理',
    saledisplaymore: '销售表现',
    mixmore: 'MIX',
    newproductsmore: '新产品',
    srdetails: 'SR详情',
    kpiset: 'KPI 设置',
    sopnew: '新产品总量KPI',
    pattenkpi: '新花纹KPI',
    sop18: 'MIX总量KPI',
    soptotal: '总量SOP',
    targetsegmentsop: '战略产品总量KPI',
    producttag: '产品标签管理',
    spnamelist: 'SP名称管理',
    cpreportmodule: '固铂报表',
    visitstorestatistics: '访店行为统计报表',
    visitplanstatistics: '拜访计划统计报表',
    customervisitstatistics: '拜访客户分布统计报表',
    networkexpansionstatistics: '网络拓展统计报表',
    planandtaskstatistics: '计划与任务统计报表',
    planandtaskreport: '计划及新开卡报表',
    tasklistbyaddress: '地区新开卡情况',
    planandtasklist: '计划与任务情况',
    cpplanandtasklist: '固铂计划与任务情况',
    tasklistbysr: 'SR新开卡情况',
    tasklistbyasm: 'ASM计划任务详情',
    sopamount: '金额SOP',
    aopamount: '金额AOP',
    daregionaop: '省份AOP',
    aopintegral: '积分AOP',
    activetotalkpi: '活跃店目标总量KPI',
    historyadjust: '金额部分实际值调整',
    fdmpermission: 'FDM数据权限',
    rsmandsp: 'SP对应关系',
    performancemodule: '团队表现管理',
    performancereport: '团队表现',
    cpperformancemodule: '固铂团队表现管理',
    cpperformancereport: '固铂团队表现',
    taskmodule: '任务管理',
    tasklist: '任务列表',
    likecommentmodule: '点赞评论管理',
    likecommentlist: '点赞评论列表',
    ccikpi: 'CCI报表',
    srintegralreport: 'SR积分报表',
    rsmsalesbonusreport: 'Region Head销售奖金报表',
    gasnsign: 'GASN门店签约情况',
    likeComment: '点赞评论列表',
    carpacarearefsrinfo: '汽车保有量查看权限',
    salesperformance: '城市销售表现（总表）',
    salesperformancecity: '城市销售表现',
    salesperformancecitytotal: '城市销售表现（总表）',
    salesperformancestore: '门店销售表现报表',
    channeldevelopment: '渠道发展报表',
    workefficiency: '工作效率报表',
    chatbot: 'chatbot',
    salesreportmodule: '销售详情',
    salesreport: '销售详情',
    allowancemodule: '津贴管理',
    oilallowance: '油费津贴',
    mealallowance: '餐费津贴',
    bailianreport: '百炼报表',
    storeonlinetmreport: '固特异e店通 by店',
    storeonlineorderreport: '固特异e店通 by订单',
    fdpreport: 'FDP报表',
    extendedwarrantyresults: '延保审核结果',
    taskassignment: '任务分配'
  },
  notice: {
    BoxWrap: {
      manage: '公告查询',
      list: '公告列表'
    },
    input: {
      appMessageTitle: '公告标题',
      appMessageStatus: '公告状态',
      startTime: '公告开始日期',
      endTime: '公告结束日期',
      isAuth: '是否授权区域'
    },
    table: {
      sequence: '序号',
      appMessageCode: '公告ID',
      appMessageTitle: '公告标题',
      noticeImgUrl: '公告封面',
      appMessageStatus: '公告状态',
      sn: '公告排序',
      startTime: '公告开始日期',
      endTime: '公告结束日期',
      createName: '创建人',
      createTime: '创建时间',
      action: '操作'
    },
    dialog: {
      pulish: '确认要发布吗',
      unpublish: '确认要撤回发布吗',
      disable: '确认要归档吗'
    },
    message: {
      publishSuccess: '发布成功',
      publishFail: '发布失败',
      unpublishSuccess: '撤回成功',
      unpublishFail: '撤回失败',
      disableSuccess: '归档成功',
      disableFail: '归档失败'
    },
    dropdown: {
      editNotice: '编辑标题',
      editArticle: '编辑文章',
      viewArticle: '查看文章',
      auth: '授权',
      deleteNotice: '删除公告',
      deleteArticle: '删除文章',
      publish: '发布',
      unpublish: '撤回发布',
      disable: '归档',
      delete: '删除'
    },
    form: {
      appMessageCode: '公告编码',
      appMessageTitle: '公告标题',
      noticeImgUrl: '公告封面',
      appMessageStatus: '公告状态',
      sn: '公告排序',
      startTime: '开始日期',
      endTime: '结束日期'
    },
    error: {
      appMessageCode: '请输入公告编码',
      appMessageTitle: '请输入公告标题',
      endTime: '请选择公告结束日期',
      noticeImgUrl: '请上传公告封面',
      upload: '上传图片失败，请重新选择'
    }
  },
  noticeContent: {
    BoxWrap: {
      manage: '',
      cancel: '取消',
      preview: '预览'
    },
    input: {},
    table: {},
    dialog: {
      back: '确认退回列表？'
    },
    dropdown: {
      mobilePreview: '手机端预览',
      pcPreview: '网页端预览',
      closePreview: '关闭预览'
    },
    form: {
      view: '查看：',
      attachment: '附件：'
    },
    error: {
      empty: '请输入文章内容'
    }
  },
  configuration: {
    common: {
      E: '启用',
      D: '禁用'
    },
    BoxWrap: {
      manage: '配置管理',
      list: '配置列表'
    },
    input: {
      holder: '请输入',
      fieldCode: '字段编码',
      directions: '说明',
      configItemName: '字段名称',
      configurationType: '配置类型',
      enableStatus: '启用状态'
    },
    form: {
      code: '编码',
      fieldCode: '字段编码',
      configItemName: '字段名称',
      remark: '备注',
      valueCN: '值（CN）',
      valueEN: '值（EN）'
    },
    table: {
      systemPk: '序号',
      fieldCode: '字段编码',
      configItemName: '字段名称',
      configurationType: '配置类型',
      configurationValues: '配置值',
      enableStatus: '启用状态',
      enableTime: '启用时间',
      action: '操作'
    },
    error: {
      configItemName: '请输入合法的字段名称'
    }
  },
  account: {
    BoxWrap: {
      manage: '用户查询',
      list: '用户列表'
    },
    input: {
      empNo: '工号',
      username: '用户中文名',
      roleCode: '角色',
      mobile: '手机号',
      email: '邮箱',
      region: '省',
      city: '市',
      district: '区',
      address: '地址',
      accountStatus: '是否启用'
    },
    table: {
      sequence: '序号',
      empNo: '工号',
      username: '用户中文名',
      usernameCn: '用户姓名',
      roleCode: '角色',
      region: '省',
      city: '市',
      district: '区',
      address: '地址',
      mobile: '手机号',
      email: '邮箱',
      accountStatus: '是否启用',
      lastUpdateName: '操作人',
      lastUpdateTime: '操作时间',
      action: '操作'
    },
    dialog: {},
    dropdown: {
      roleAuth: '角色授权'
    },
    form: {
      empNo: '工号',
      username: '用户中文名',
      usernameCn: '用户姓名',
      mobile: '手机号',
      email: '邮箱',
      region: '省',
      city: '市',
      district: '区',
      address: '地址',
      accountStatus: '是否启用'
    },
    error: {
      empNo: '请输入合法的工号',
      username: '请输入合法的用户中文名',
      email: '请输入合法的邮箱',
      mobile: '请输入合法的手机号',
      address: '请输入地址'
    }
  },
  reportModule: {
    table: {
      monthKPI_title: '',
      quarterKPI_title: '',
      tpp: 'TPP签约量',
      targetSales: '目标销量',
      acturlSales: '实际销量',
      targetSales18: '18+目标销量',
      acturlSales18: '18+实际销量',
      targetStoreNum: '目标签约店数',
      acturlStoreNum: '实际签约店数',
      targetActiveStoreNum: '目标活跃店家数',
      acturlActiveStoreNum: '实际活跃店家数',
      activeStoreNum18: '18+实际活跃店家数',
      year: '年'
    },
    storeDetail: '门店明细',
    month: '月份',
    ordersTable: {
      brand: '品牌',
      tpp: 'TPP',
      orderNums: '月度目标销量',
      orderQuat: '下单条数',
      confirmQuat: '确认条数',
      waitConfirmQuat: '当月待确认条数',
      historyConfirmQuat: '历史待确认条数'
    },
    storeCode: '客户编号',
    storeName: '门店名称',
    phone: '电话',
    tppCount: 'TPP签约量',
    proviceCity: '省/市',
    exportSROrders: '导出零售店订单报表',
    storeOrders: {
      storeCode: '客户编号',
      rtlRegion: '省份',
      rtlCity: '城市',
      rtlFullName: '店名',
      serviceProviderName: '服务商名称',
      empName: 'SR姓名',
      rtlRtmCategory: 'RTM类型',
      retailerType: '零售店类别',
      tpp: 'TPP',
      st: 'ST',
      gy18Plus: 'GY 18+',
      january: 'GY Jan',
      february: 'GY Feb',
      march: 'GY Mar',
      april: 'GY Apr',
      may: 'GY May',
      june: 'GY Jun',
      july: 'GY Jul',
      august: 'GY Aug',
      september: 'GY Sep',
      october: 'GY Oct',
      november: 'GY Nov',
      december: 'GY Dec',
      janEighteenActualSalesQty: 'ST Jan',
      febEighteenActualSalesQty: 'ST Feb',
      marEighteenActualSalesQty: 'ST Mar',
      aprEighteenActualSalesQty: 'ST Apr',
      mayEighteenActualSalesQty: 'ST May',
      junEighteenActualSalesQty: 'ST Jun',
      julEighteenActualSalesQty: 'ST Jul',
      augEighteenActualSalesQty: 'ST Aug',
      sepEighteenActualSalesQty: 'ST Sep',
      octEighteenActualSalesQty: 'ST Oct',
      novEighteenActualSalesQty: 'ST Nov',
      decEighteenActualSalesQty: 'ST Dec'
    },
    error: {
      rimSize: '规格查询关键字数不能少于5个',
      region: '请选择查询的省市信息'
    },
    startQuarter: '开始季度',
    endQuarter: '结束季度',
    quarterError1: '开始季度不能大于结束季度',
    quarterError2: '时间跨度不能超过2年',
    filterText: '筛选',
    carpacTab1: '所辖区域车辆保有量',
    carpacTab2: '主流规格',
    carpacTab3: '主流车型',
    carparcText: '市场预估保有量总值',
    plus18: '18+',
    plus18Percent: '18+占比',
    rimSize: '规格',
    rim: '轮毂尺寸',
    rimCarparc: '保有量',
    top5: '排名前五主流车型',
    mainCarType: '主要车型',
    sequence: '排名',
    salesReport: {
      spName: '服务商名称',
      rsmEmpNo: 'Region Head员工号',
      rsmName: 'Region Head姓名',
      orderQty: 'MTD零售店订单数量',
      deliverQty: 'MTD服务商已确认数量',
      receiptQty: 'MTD门店确认收货数量',
      remark: '备注'
    }
  },
  orderRecommended: {
    select: {
      startDay: '开始日期',
      endDay: '结束日期',
      empName: 'SR姓名',
      empNo: 'SR工号'
    },
    table: {
      srEmpNo: 'SR工号',
      srEmpName: 'SR姓名',
      recommendStoreFrequency: '推荐订单店次',
      recommendStoreQty: '推荐订单店数',
      recommendSizeAddQty: '推荐规格数量(累计)',
      recommendSizeRemoveQty: '推荐规格数量(去重)',
      recommendTireQty: '推荐总轮胎数',
      viewStoreAddQty: '门店查看数量(累计)',
      viewStoreRemoveQty: '门店查看数量(去重)',
      purchaseStoreAddQty: '加购门店数量(累计)',
      purchaseStoreRemoveQty: '加购门店数量(去重)'
    }
  },
  appVersion: {
    BoxWrap: {
      manage: '版本管理'
    },
    button: {
      checkHis: '查看历史',
      changeVersion: '更改版本',
      clearCache: '清除缓存',
      upload: '点击上传'
    },
    table: {
      hisList: '历史列表',
      displayVersion: '版本号',
      versionDesc: '版本说明',
      downloadUrl: '下载地址',
      lastUpdateTime: '更新时间',
      createTime: '创建时间',
      appPlatformType: '所属平台',
      appBizType: '业务类型'
    },
    form: {
      uploadApk: '上传apk'
    },
    dialog: {
      content1: '确定将当前版本设置为发布版本吗？',
      content2: '确定将清除用户缓存吗？',
      releaseSuccess: '发布成功',
      clearSuccess: '清除成功'
    },
    error: {
      appPlatformType: '请选择',
      displayVersion: '请填写合法的APP版本号',
      downloadUrl: '请上传文件',
      versionDesc: '请填写合法的版本说明',
      uploadFail: '上传失败，请重新选择'
    }
  },
  srDetail: {
    visitStoreNum: '门店拜访数量',
    number: '数量',
    time: '时长',
    storePlan: '门店拜访任务',
    allPlan: '全部任务',
    radio: '占比',
    visitStoreList: '访问记录列表',
    all: '全部',
    storeVisit: '门店拜访',
    other: '其他',
    table: {
      date: '日期',
      thing: '事项',
      time: '签到时间',
      store: '门店',
      monthTimes: '当月拜访次数'
    }
  },
  sopTotal: {
    serviceProviderID: '服务商编号',
    serviceProviderName: '服务商名称',
    salesMonth1: '1月目标销量',
    salesMonth2: '2月目标销量',
    salesMonth3: '3月目标销量',
    salesMonth4: '4月目标销量',
    salesMonth5: '5月目标销量',
    salesMonth6: '6月目标销量',
    salesMonth7: '7月目标销量',
    salesMonth8: '8月目标销量',
    salesMonth9: '9月目标销量',
    salesMonth10: '10月目标销量',
    salesMonth11: '11月目标销量',
    salesMonth12: '12月目标销量'
  },
  sop18: {
    kpiType: 'KPI 类型',
    prodSize: '尺寸',
    sales18Month1: '1月目标销量',
    sales18Month2: '2月目标销量',
    sales18Month3: '3月目标销量',
    sales18Month4: '4月目标销量',
    sales18Month5: '5月目标销量',
    sales18Month6: '6月目标销量',
    sales18Month7: '7月目标销量',
    sales18Month8: '8月目标销量',
    sales18Month9: '9月目标销量',
    sales18Month10: '10月目标销量',
    sales18Month11: '11月目标销量',
    sales18Month12: '12月目标销量'
  },
  targetsegmentsop: {
    kpiType: 'KPI 类型',
    salesSUVMonth1: '1月SUV目标销量',
    salesLUXMonth1: '1月LUX目标销量',
    salesEVMonth1: '1月EV目标销量',
    salesSUVMonth2: '2月SUV目标销量',
    salesLUXMonth2: '2月LUX目标销量',
    salesEVMonth2: '2月EV目标销量',
    salesSUVMonth3: '3月SUV目标销量',
    salesLUXMonth3: '3月LUX目标销量',
    salesEVMonth3: '3月EV目标销量',
    salesSUVMonth4: '4月SUV目标销量',
    salesLUXMonth4: '4月LUX目标销量',
    salesEVMonth4: '4月EV目标销量',
    salesSUVMonth5: '5月SUV目标销量',
    salesLUXMonth5: '5月LUX目标销量',
    salesEVMonth5: '5月EV目标销量',
    salesSUVMonth6: '6月SUV目标销量',
    salesLUXMonth6: '6月LUX目标销量',
    salesEVMonth6: '6月EV目标销量',
    salesSUVMonth7: '7月SUV目标销量',
    salesLUXMonth7: '7月LUX目标销量',
    salesEVMonth7: '7月EV目标销量',
    salesSUVMonth8: '8月SUV目标销量',
    salesLUXMonth8: '8月LUX目标销量',
    salesEVMonth8: '8月EV目标销量',
    salesSUVMonth9: '9月SUV目标销量',
    salesLUXMonth9: '9月LUX目标销量',
    salesEVMonth9: '9月EV目标销量',
    salesSUVMonth10: '10月SUV目标销量',
    salesLUXMonth10: '10月LUX目标销量',
    salesEVMonth10: '10月EV目标销量',
    salesSUVMonth11: '11月SUV目标销量',
    salesLUXMonth11: '11月LUX目标销量',
    salesEVMonth11: '11月EV目标销量',
    salesSUVMonth12: '12月SUV目标销量',
    salesLUXMonth12: '12月LUX目标销量',
    salesEVMonth12: '12月EV目标销量'
  },
  pattenkpi: {
    rsmId: 'Region Head工号',
    rsmName: 'Region Head姓名',
    asmId: 'ASM工号',
    asmName: 'ASM姓名',
    srId: 'SR工号',
    srName: 'SR姓名',
    role: '角色',
    pattern: '新品花纹',
    region: '区域',
    salesAMGMonth1: '1月AMG目标销量',
    salesRTMonth1: '1月RT目标销量',
    salesEDMonth1: '1月ED目标销量',
    salesACTMonth1: '1月ACT目标销量',
    salesAMGMonth2: '2月AMG目标销量',
    salesRTMonth2: '2月RT目标销量',
    salesEDMonth2: '2月ED目标销量',
    salesACTMonth2: '2月ACT目标销量',
    salesAMGMonth3: '3月AMG目标销量',
    salesRTMonth3: '3月RT目标销量',
    salesEDMonth3: '3月ED目标销量',
    salesACTMonth3: '3月ACT目标销量',
    salesAMGMonth4: '4月AMG目标销量',
    salesRTMonth4: '4月RT目标销量',
    salesEDMonth4: '4月ED目标销量',
    salesACTMonth4: '4月ACT目标销量',
    salesAMGMonth5: '5月AMG目标销量',
    salesRTMonth5: '5月RT目标销量',
    salesEDMonth5: '5月ED目标销量',
    salesACTMonth5: '5月ACT目标销量',
    salesAMGMonth6: '6月AMG目标销量',
    salesRTMonth6: '6月RT目标销量',
    salesEDMonth6: '6月ED目标销量',
    salesACTMonth6: '6月ACT目标销量',
    salesAMGMonth7: '7月AMG目标销量',
    salesRTMonth7: '7月RT目标销量',
    salesEDMonth7: '7月ED目标销量',
    salesACTMonth7: '7月ACT目标销量',
    salesAMGMonth8: '8月AMG目标销量',
    salesRTMonth8: '8月RT目标销量',
    salesEDMonth8: '8月ED目标销量',
    salesACTMonth8: '8月ACT目标销量',
    salesAMGMonth9: '9月AMG目标销量',
    salesRTMonth9: '9月RT目标销量',
    salesEDMonth9: '9月ED目标销量',
    salesACTMonth9: '9月ACT目标销量',
    salesAMGMonth10: '10月AMG目标销量',
    salesRTMonth10: '10月RT目标销量',
    salesEDMonth10: '10月ED目标销量',
    salesACTMonth10: '10月ACT目标销量',
    salesAMGMonth11: '11月AMG目标销量',
    salesRTMonth11: '11月RT目标销量',
    salesEDMonth11: '11月ED目标销量',
    salesACTMonth11: '11月ACT目标销量',
    salesAMGMonth12: '12月AMG目标销量',
    salesRTMonth12: '12月RT目标销量',
    salesEDMonth12: '12月ED目标销量',
    salesACTMonth12: '12月ACT目标销量',
    salesMonth1: '1月目标销量',
    salesMonth2: '2月目标销量',
    salesMonth3: '3月目标销量',
    salesMonth4: '4月目标销量',
    salesMonth5: '5月目标销量',
    salesMonth6: '6月目标销量',
    salesMonth7: '7月目标销量',
    salesMonth8: '8月目标销量',
    salesMonth9: '9月目标销量',
    salesMonth10: '10月目标销量',
    salesMonth11: '11月目标销量',
    salesMonth12: '12月目标销量'
  },
  sopNew: {
    kpiType: 'KPI 类型',
    pattern: '新品花纹',
    salesNewProtMonth1: '1月新品目标销量',
    salesNewProtMonth2: '2月新品目标销量',
    salesNewProtMonth3: '3月新品目标销量',
    salesNewProtMonth4: '4月新品目标销量',
    salesNewProtMonth5: '5月新品目标销量',
    salesNewProtMonth6: '6月新品目标销量',
    salesNewProtMonth7: '7月新品目标销量',
    salesNewProtMonth8: '8月新品目标销量',
    salesNewProtMonth9: '9月新品目标销量',
    salesNewProtMonth10: '10月新品目标销量',
    salesNewProtMonth11: '11月新品目标销量',
    salesNewProtMonth12: '12月新品目标销量'
  },
  productTag: {
    vehicleType: '车型',
    pattern: '新品花纹',
    materialCode: 'SAP产品物料编号',
    materialDescription: '产品描述',
    vehicleTypeSuv: 'SUV',
    vehicleTypeLux: 'LUX',
    vehicleTypeEv: 'EV',
    vehicleTypeNew: 'New Product',
    yearOfNew: '新品年份',
    patternAmg: 'AMG',
    patternRt: 'RT',
    patternEd: 'ED',
    patternAct: 'ACT',
    productIntegral: '产品积分',
    fixedCost: '固定成本',
    variableCost: '可变成本',
    exportProductInfo: '导出产品表',
    productInfoFileName: '产品信息'
  },
  spNameList: {
    spSapId: '服务商ID',
    spFullName: '服务商中文名',
    spEnglishName: '服务商英文名',
    spShortNameCn: '中文简称'
  },
  planAndTaskReport: {
    newVisitNum: '新开卡数量',
    listTable: {
      a01PlanCount: '创建访店计划数量',
      a01PlanCountMix: '访店计划数量占比',
      a01TaskCount: '创建访店任务数量',
      a01TaskCountMix: '访店任务数量占比',
      a01PlanTime: '访店计划时长',
      a01PlanTimeMix: '访店计划时长占比',
      a01TaskTime: '访店任务时长',
      a01TaskTimeMix: '访店任务时长占比',
      a02PlanCount: '潜在客户拜访计划数量',
      a02PlanTime: '潜在客户拜访计划时长',
      a07PlanCount: '服务商/经销商拜访计划数量',
      a07TaskCount: '服务商/经销商拜访任务数量',
      a07PlanTime: '服务商/经销商拜访计划时长',
      a07TaskTime: '服务商/经销商拜访任务时长',
      a05PlanCount: '培训计划数量',
      a05TaskCount: '培训任务数量',
      a05PlanTime: '培训计划时长',
      a05TaskTime: '培训任务时长',
      a06PlanCount: '会议计划数量',
      a06TaskCount: '会议任务数量',
      a06PlanTime: '会议计划时长',
      a06TaskTime: '会议任务时长',
      a03PlanCount: '门店Hunting计划数量',
      a03TaskCount: '门店Hunting任务数量',
      a03PlanTime: '门店Hunting计划时长',
      a03TaskTime: '门店Hunting任务时长',
      a04PlanCount: '路演Seminar计划数量',
      a04TaskCount: '路演Seminar任务数量',
      a04PlanTime: '路演Seminar计划时长',
      a04TaskTime: '路演Seminar任务时长',
      a08PlanCount: '休假计划数量',
      a08TaskCount: '休假任务数量',
      a08PlanTime: '休假计划时长',
      a08TaskTime: '休假任务时长',
      a09PlanCount: '其他计划数量',
      a09TaskCount: '其他任务数量',
      a09PlanTime: '其他计划时长',
      a09TaskTime: '其他任务时长',
      a13PlanCount: '中餐计划数量',
      a13TaskCount: '中餐任务数量',
      a13PlanTime: '中餐计划时长',
      a13TaskTime: '中餐任务时长',
      a14PlanCount: '停车计划数量',
      a14TaskCount: '停车任务数量',
      a14PlanTime: '停车计划时长',
      a14TaskTime: '停车任务时长',
      a15PlanCount: '取车计划数量',
      a15TaskCount: '取车任务数量',
      a15PlanTime: '取车计划时长',
      a15TaskTime: '取车任务时长'
    }
  },
  sopAmount: {
    amountType: 'KPI类型',
    currencyType: '货币类型',
    targetMonth1: '1月目标量',
    targetMonth2: '2月目标量',
    targetMonth3: '3月目标量',
    targetMonth4: '4月目标量',
    targetMonth5: '5月目标量',
    targetMonth6: '6月目标量',
    targetMonth7: '7月目标量',
    targetMonth8: '8月目标量',
    targetMonth9: '9月目标量',
    targetMonth10: '10月目标量',
    targetMonth11: '11月目标量',
    targetMonth12: '12月目标量'
  },
  aopAmount: {
    rsmId: 'Region Head工号',
    rsmName: 'Region Head名称',
    currencyType: '货币',
    q1Target: 'Q1目标金额',
    q2Target: 'Q2目标金额',
    q3Target: 'Q3目标金额',
    q4Target: 'Q4目标金额'
  },
  aopIntegral: {
    rsmId: 'Region Head工号',
    rsmName: 'Region Head名称',
    asmId: 'ASM工号',
    asmName: 'ASM姓名',
    srId: 'SR工号',
    srName: 'SR姓名',
    q1TargetQty: 'Q1积分目标',
    q2TargetQty: 'Q2积分目标',
    q3TargetQty: 'Q3积分目标',
    q4TargetQty: 'Q4积分目标',
    oneTargetQty: '1月目标数量',
    twoTargetQty: '2月目标数量',
    threeTargetQty: '3月目标数量',
    fourTargetQty: '4月目标数量',
    fiveTargetQty: '5月目标数量',
    sixTargetQty: '6月目标数量',
    sevenTargetQty: '7月目标数量',
    eightTargetQty: '8月目标数量',
    nineTargetQty: '9月目标数量',
    tenTargetQty: '10月目标数量',
    elevenTargetQty: '11月目标数量',
    twelveTargetQty: '12月目标数量',
    aopFileName: '积分AOP模板'
  },
  historyAdjust: {
    rsmId: 'Region Head工号',
    rsmName: 'Region Head名称',
    currencyType: '货币类型',
    amountType: 'KPI类型',
    amountMonth1: '1月实际数据',
    amountMonth2: '2月实际数据',
    amountMonth3: '3月实际数据',
    amountMonth4: '4月实际数据',
    amountMonth5: '5月实际数据',
    amountMonth6: '6月实际数据',
    amountMonth7: '7月实际数据',
    amountMonth8: '8月实际数据',
    amountMonth9: '9月实际数据',
    amountMonth10: '10月实际数据',
    amountMonth11: '11月实际数据',
    amountMonth12: '12月实际数据'
  },
  activeTotalKpi: {
    targetMonth1: '1月活跃店目标',
    targetMonth2: '2月活跃店目标',
    targetMonth3: '3月活跃店目标',
    targetMonth4: '4月活跃店目标',
    targetMonth5: '5月活跃店目标',
    targetMonth6: '6月活跃店目标',
    targetMonth7: '7月活跃店目标',
    targetMonth8: '8月活跃店目标',
    targetMonth9: '9月活跃店目标',
    targetMonth10: '10月活跃店目标',
    targetMonth11: '11月活跃店目标',
    targetMonth12: '12月活跃店目标'
  },
  fdmPermission: {
    fdmEmpNo: 'FDM工号',
    fdmEmpName: 'FDM名称',
    rsmEmpNo: 'Region Head工号',
    rsmEmpName: 'Region Head名称'
  },
  RSMAndSP: {
    rsmEmpNo: '工号',
    rsmEmpName: '名称',
    roleCode: '角色',
    spSapId: '服务商编号',
    spFullName: '服务商名称'
  },
  performanceReport: {
    BoxWrap: {
      manage: '团队表现'
    },
    tab: {
      newCustomer: '新客户',
      visiting: '访店行为',
      visitPlan: '拜访计划',
      customerDistribution: '客户分布',
      order: '订单',
      warranty: '售出延保',
      cci: 'e店通&延保',
      month: '月度',
      quarter: '季度',
      year: '年度',
      week: '周'
    },
    select: {
      month: '月份',
      quarter: '季度',
      year: '年份',
      week: '周',
      rsm: 'Region Head'
    },
    input: {},
    table: (_table = {
      // common
      srEmpNo: 'SR ID',
      srEmpName: 'SR Name',
      action: '操作',
      // 新客户
      newRegisteroty: '新注册店数',
      newRegisterConfirmedQty: '新注册门店的当月销量',
      newRegisterConfirmedQty_y: '新注册门店的当年销量',
      newsignQty: '新签约门店数',
      newSignConfirmedQty: '新签约店的当月销量',
      newSignConfirmedQty_y: '新签约店的当年销量',
      confirmedQty: '当年确认收货数',
      // 访店行为
      visitQty: '零售店拜访天数',
      visitDuration: '零售店访店时长',
      visitStoreQty: '零售店访店店数',
      visitStoreFrequency: '零售店访店店次',
      avgStoreFrequency: '平均单店访问次数',
      unVisitDuration: '非零售店访店时长',
      unVisitDurationRateString: '非零售店访店时长占比',
      inventoryStoreFrequency: '盘库店次',
      policyStoreFrequency: '政策讲解店次',
      warrantyStoreFrequency: '沟通延保店次',
      // 拜访计划
      planQty: '周创建计划天数',
      visitPlanQty: '周创建拜访计划天数',
      taskQty: '周创建任务天数',
      visitTaskQty: '周创建拜访任务天数'
    }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_table, "visitStoreFrequency", '零售店访店店次'), "z02StoreFrequency", 'Z02店次'), "z02Proportion", 'Z02占比'), "prospectsStoreFrequency", '潜客店次'), "prospectsProportion", '潜客占比'), "gasnStoreFrequency", 'GASN店次'), "gasnProportion", 'GASN占比'), "tireStoreFrequency", '非GY/CP门店店次'), "tireProportion", '非GY/CP门店占比'), "visitStoreFrequency", '零售店访店店次'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_table, "visitStoreQty", '零售店访店店数'), "activeStoreQty", '当月拜访且当月活跃门店数 '), "activeProportion", '活跃门店占拜访门店比'), "recommendStoreFrequency", '订单推荐店次'), "recommendStoreQty", '订单推荐店数'), "recommendTireQty", '推荐总轮胎数'), "purchaseStoreQty", '加购门店数'), "purchaseProportion", '加购门店占推荐门店比'), "registerStoreQty", '当前注册门店数'), "signStoreQty", '当前签约门店数'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_table, "warrantyStoreQty", '参加延保门店数'), "eShopStoreCount", 'e店通活跃店数'), "unsignWarrantyStoreQty", '参加延保但未签TPP门店数'), "rtmConfirmedQty", 'RTM销量'), "warrantyQty", '延保条数'), "seventeenWarrantyQty", '延保条数17&+'), "openMallStoreCount", 'e店通已开通店数'), "approvedCount", '延保审核通过条数'), "pendingApprovedCount", '延保待审核条数'), "notApprovedCount", '延保审核未通过条数'), (0, _defineProperty2.default)(_table, "totalTireCount", 'e店通轮胎条数'))
  },
  CPPerformanceReport: {
    BoxWrap: {
      manage: '固铂团队表现'
    },
    tab: {
      visiting: '访店行为',
      visitPlan: '拜访计划',
      customerDistribution: '客户分布',
      networkExpansion: '网络拓展',
      planTask: '计划与任务',
      month: '月度',
      quarter: '季度',
      year: '年度',
      week: '周'
    },
    select: {
      month: '月份',
      quarter: '季度',
      year: '年份',
      week: '周',
      rsm: 'Region Head',
      srEmpNo: 'SR ID',
      srEmpName: 'SR Name',
      date: '日期'
    },
    input: {},
    table: (_table2 = {
      // common
      srEmpNo: 'SR ID',
      srEmpName: 'SR Name',
      action: '操作',
      // 访店行为
      visitQty: '零售店拜访天数',
      visitDuration: '零售店访店时长',
      visitStoreQty: '零售店访店店数',
      visitStoreFrequency: '零售店访店店次',
      avgStoreFrequency: '平均单店访店次数',
      spVisitQty: '经销商拜访天数',
      spVisitDuration: '经销商拜访时长',
      unVisitDuration: '非零售店&经销商访店工作时长',
      unVisitDurationRate: '非零售店&经销商访店工作时长占比',
      unVisitDurationRateString: '非零售店&经销商访店工作时长占比',
      inventoryStoreFrequency: '盘库店次',
      policyStoreFrequency: '政策讲解店次',
      warrantyStoreFrequency: '沟通延保店次',
      // 拜访计划
      planQty: '周创建计划天数',
      visitPlanQty: '周创建拜访计划天数',
      taskQty: '周创建任务天数',
      visitTaskQty: '周创建拜访任务天数'
    }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_table2, "visitStoreFrequency", '零售店访店店次'), "visitClubQty", '俱乐部访店店数'), "visitClubFrequency", '俱乐部访店店次'), "visitClubFrequencyMix", '俱乐部访店店次占比'), "visitCrossStoreQty", '改装店及改装连锁店访店店数'), "visitCrossStoreFrequency", '改装店及改装连锁店访店店次'), "visitCrossStoreFrequencyMix", '改装店及改装连锁店访店店次占比'), "z02StoreQty", 'Z02拜访店数'), "z02StoreFrequency", 'Z02拜访店次'), "z02StoreFrequencyMix", 'Z02拜访店次占比'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_table2, "newStoreCount", '新开卡店总数'), "newStoreClubCount", '新开卡俱乐部店数'), "newStoreModificationCount", '新开卡改装或改装连锁店数'), "newStoreBaiLianCount", '新开卡百炼店数'))
  },
  taskList: {
    BoxWrap: {
      manage: '任务查询',
      list: '任务列表'
    },
    input: {
      readFlag: '读取状态',
      dateRange: '创建时间范围',
      startTimeHolder: '开始时间',
      endTimeHolder: '结束时间',
      taskType: '任务类型',
      srEmpNo: 'SR ID'
    },
    table: {
      srEmpNo: 'SR ID',
      srEmpName: 'SR',
      taskFromType: '任务来源类型',
      taskType: '任务类型',
      readFlag: '读取状态',
      rtlRtmCategory: 'RTM类型',
      retailerType: '零售店类型',
      rtlAddress: '门店地址',
      rtlFullName: '门店名称',
      distributionName: '分配人',
      createBy: '创建人',
      nowTime: '任务分配日期',
      signBoardBidFlag: '竞品店招',
      visitPurpose: '拜访目的',
      dueTime: '截止日期',
      remark: '备注',
      action: '操作'
    },
    form: {
      srEmpNo: 'SR ID',
      srEmpName: 'SR',
      taskFromType: '任务来源类型',
      taskType: '任务类型',
      readFlag: '读取状态',
      rtlRtmCategory: 'RTM类型',
      retailerType: '零售店类型',
      rtlAddress: '省市区',
      rtlFullName: '门店名称',
      distributionName: '分配人',
      createBy: '创建人',
      nowTime: '任务分配日期',
      signBoardBidFlag: '竞品店招',
      visitPurpose: '拜访目的',
      dueTime: '截止日期',
      remark: '备注'
    }
  },
  cciKpi: {
    form: {
      srEmpNo: 'SR工号',
      srEmpName: 'SR姓名',
      month: '月份',
      pcd: '省市区',
      rtlRtmCategory: 'RTM类型',
      signFlag: '是否签约',
      storeName: '门店名称'
    },
    table: {
      rtlFullName: '门店名称',
      storeCode: '门店编码',
      rtlRegion: '省',
      rtlCity: '市',
      rtlDistrict: '区',
      spSapId: '服务商编码',
      spFullName: '服务商名称',
      rtlRtmCategory: 'RTM 类型',
      signFlag: '是否签约',
      retailerType: '零售商类型',
      srEmpNo: 'SR 工号',
      srEmpName: 'SR 姓名',
      confirmedQty: '当月确认收货条数',
      warrantyQty: '延保总条数',
      seventeenWarrantyQty: '延保17&+条数'
    }
  },
  GASNSign: {
    storeCode: '门店编号',
    storeName: '门店名称',
    signTimeMix: '签约日期开始',
    signTimeMax: '签约日期结束',
    signEndTimMix: '合同到期日期开始',
    signEndTimeMax: '合同到期日期结束',
    status: '门店状态',
    signTime: '签约日期',
    signEndTime: '合同到期日期'
  },
  LikeComment: {
    sender: '发送人',
    receiver: '接收人',
    startTime: '开始时间',
    endTime: '结束时间',
    originType: '点赞来源',
    sendTime: '发送日期',
    readFlag: '读取状态',
    messageContent: '推送内容',
    wholeMessageContent: '内容'
  },
  carpacAreaRefSrInfo: {
    empNo: '工号',
    empName: '姓名'
  },
  taskListByASM: {
    planTaskType: '类型',
    planTaskFlag: '事项',
    rtlFullName: '门店名称',
    customerName: '潜在客户名称',
    customerAddress: '潜在客户地址',
    visitPurposeOne: '拜访目的1',
    visitPurposeTwo: '拜访目的2',
    asmVisitPurpose: 'ASM拜访目的',
    collaborativeFlag: '协同访店',
    srEmpNo: '协同SR工号',
    srEmpName: '协同SR姓名',
    remark: '简要说明',
    asmVisitSummary: 'ASM访店总结'
  },
  channelDevelopment: {
    srEmpNo: 'SR工号',
    rsmName: 'Region Head姓名',
    asmName: 'ASM姓名',
    srEmpName: 'SR姓名',
    tppStoreTargetYtd: '当年TPP签约店数目标',
    tppSignedYtd: '当年TPP签约店数量',
    activeStoreTargetQtd: '当季度活跃店数目标',
    activeStoreQtd: '当季活跃店数量',
    visitBailianStore: '当月拜访或反馈百炼店数量',
    newSefStore: '当月新开卡数量',
    newRegisterQty: '当月新注册店数',
    newRegisterConfirmedQty: '新注册门店的当月销量',
    newSignQty: '当月新签约店数',
    newSignConfirmedQty: '新签约店的当月销量',
    activeStore: '当月活跃店数量',
    oneYearExpiredGasnStore: '一年内到期GASN店数量',
    halfYearExpiredGasnStore: '半年内到期GASN店数量',
    overdueGasnStore: '合同已超期GASN店数量'
  },
  workEfficiency: {
    srEmpNo: 'SR工号',
    rsmName: 'Region Head姓名',
    asmName: 'ASM姓名',
    srEmpName: 'SR姓名',
    visitQty: '当月零售店拜访天数',
    visitDuration: '当月零售店访店时长',
    visitStoreFrequency: '当月零售店访店店次',
    visitStoreQty: '当月零售店拜访店数',
    recommendStoreFrequency: '当月订单推荐店次',
    recommendStoreQty: '当月订单推荐店数',
    purchaseStoreQty: '当月加购门店数',
    unVisitDuration: '当月非零售店访店时长',
    totalWorkDuration: '当月总工作时长'
  },
  salesPerformance: {
    month: '月份',
    srEmpNo: 'SR工号',
    srEmpName: 'SR姓名',
    pc: '省/市',
    pcd: '省市区',
    region: '省份',
    city: '城市',
    cityAop: 'AOP目标分解',
    aopGap: 'MTD实际与AOP差值',
    district: '区县',
    storeCode: '门店编号',
    storeName: '门店名称',
    empName: 'SR姓名',
    retailerType: '零售店类型',
    storeType: '门店类型',
    tppQty: 'TPP签约条数',
    saleQty: '当月销量',
    actualEighteenQty: '当月18+销量',
    luxQty: '当月LUX销量',
    suvQty: '当月SUV销量',
    evQty: '当月EV销量',
    atcQty: '当月ACT销量',
    amgQty: '当月AMG销量',
    a6Qty: '当月A6销量',
    newProduct1Qty: '当月AMG/AMG SUV EDR销量',
    newProduct2Qty: '当月EF1 A6销量',
    newProduct3Qty: '当月EF1 A6 SUV销量',
    newProduct4Qty: '当月EDS/ED series销量',
    warrantyQty: '当月延保条数',
    salesIntegral: '当季销售积分值',
    totalSaleQty: '当年总销量',
    m1SaleQty: 'JAN ST',
    m2SaleQty: 'FEB ST',
    m3SaleQty: 'MAR ST',
    m4SaleQty: 'APR ST',
    m5SaleQty: 'MAR ST',
    m6SaleQty: 'JUN ST',
    m7SaleQty: 'JUL ST',
    m8SaleQty: 'AUG ST',
    m9SaleQty: 'SEP ST',
    m10SaleQty: 'OCT ST',
    m11SaleQty: 'NOV ST',
    m12SaleQty: 'DEC ST'
  },
  SRIntegralReport: {
    rsmEmpName: 'Region Head姓名',
    asmEmpName: 'ASM姓名',
    srEmpNo: 'SR员工号',
    srEmpName: 'SR姓名',
    month: '月份',
    integralQty: '当月积分值',
    quarterTargetIntegralQty: '季度积分目标',
    actualActiveStoreQty: '当月活跃店数',
    quarterTargetActiveStoreQty: '季度活跃店月均目标'
  },
  RSMSalesBonusReport: {
    rsmEmpNo: 'Region Head员工号',
    rsmEmpName: 'Region Head姓名',
    m1Income: '1月营业收入',
    m2Income: '2月营业收入',
    m3Income: '3月营业收入',
    q1Income: 'Q1总营业收入',
    q1TargetQty: 'Q1总营业收入目标',
    q1AchievementRate: 'Q1总营业收入达成率',
    q1IncomeRateString: 'Q1总营业收入达成率（%）',
    m4Income: '4月营业收入',
    m5Income: '5月营业收入',
    m6Income: '6月营业收入',
    q2Income: 'Q2总营业收入',
    q2TargetQty: 'Q2总营业收入目标',
    q2AchievementRate: 'Q2总营业收入达成率',
    q2IncomeRateString: 'Q2总营业收入达成率（%）',
    m7Income: '7月营业收入',
    m8Income: '8月营业收入',
    m9Income: '9月营业收入',
    q3Income: 'Q3总营业收入',
    q3TargetQty: 'Q3总营业收入目标',
    q3AchievementRate: 'Q3总营业收入达成率',
    q3IncomeRateString: 'Q3总营业收入达成率（%）',
    m10Income: '10月营业收入',
    m11Income: '11月营业收入',
    m12Income: '12月营业收入',
    q4Income: 'Q4总营业收入',
    q4TargetQty: 'Q4总营业收入目标',
    q4AchievementRate: 'Q4总营业收入达成率',
    q4IncomeRateString: 'Q4总营业收入达成率（%）'
  },
  DARegionAop: {
    BoxWrap: {
      manage: '省份AOP查询',
      list: '省份AOP列表'
    },
    year: '年份',
    regionCode: '省份编码',
    region: '省份',
    brand: '品牌',
    oneSalesTargetQty: '1月目标量',
    twoSalesTargetQty: '2月目标量',
    threeSalesTargetQty: '3月目标量',
    fourSalesTargetQty: '4月目标量',
    fiveSalesTargetQty: '5月目标量',
    sixSalesTargetQty: '6月目标量',
    sevenSalesTargetQty: '7月目标量',
    eightSalesTargetQty: '8月目标量',
    nineSalesTargetQty: '9月目标量',
    tenSalesTargetQty: '10月目标量',
    elevenSalesTargetQty: '11月目标量',
    twelveSalesTargetQty: '12月目标量'
  },
  bailianReport: {
    input: {
      date: '客户创建日期',
      feedbackDate: '反馈日期',
      baiLianStoreName: '百炼店名',
      storeBrand: '门店品牌',
      empNo: '首次反馈或开卡SR工号',
      empName: '首次反馈或开卡SR姓名',
      provinceCityDistrict: '百炼省市区',
      dataHolder: '请选择日期',
      exportFailed: '导出失败'
    },
    exportFileName: '百炼明细报表',
    exportSumFileName: '百炼汇总报表',
    baiLianStoreId: '百炼编号',
    baiLianStoreName: '百炼店名',
    baiLianAddress: '百炼地址',
    baiLianProvince: '百炼省',
    baiLianCity: '百炼市',
    baiLianDistrict: '百炼区',
    baiLianPhone: '百炼联系电话',
    businessStatus: '百炼营业状态',
    score: 'Score',
    storeBrand: '门店品牌',
    monthTireSalesAvg: '轮胎月均总销量',
    empNo: '首次反馈或开卡SR工号',
    empName: '首次反馈或开卡SR姓名',
    region: '销售区域',
    feedbackContent: '意见反馈',
    feedbackDay: '反馈时间',
    relatedStoreId: '关联门店',
    handleRelatedStoreId: '手动关联门店',
    rtlSapId: 'SFE客户编号',
    rtlFullName: 'SFE店名',
    rtlAddress: 'SFE客户地址',
    createTime: '客户创建日期',
    latestSubmitDatetime: '最近一次拜访日期',
    latestDetailOne: '最近一次访店细节描述1',
    latestDetailTwo: '最近一次访店细节描述2',
    evaluateRate: '门店评分',
    acceptTerms: '是否接受帐期',
    urgentDeliveryTime: '紧急订单物流可接受到货时间',
    regularDeliveryTime: '常规订单物流可接受到货时间',
    willingToRtmOrder: '是否愿意RTM下单',
    goodContent: '正面评价',
    badContent: '负面评价',
    otherContent: '其他评价'
  },
  storeonlinetmreport: {
    input: {
      retailerId: '客户编号',
      retailerName: '店名',
      empNo: 'SR工号',
      empName: 'SR姓名',
      month: '年月',
      dataHolder: '请选择日期',
      exportFailed: '导出失败'
    },
    exportFileName: '固特异e店通 by店',
    exportSumFileName: '固特异e店通 by店',
    retailerId: '客户编号',
    retailerName: '店名',
    empNo: 'SR工号',
    empName: 'SR姓名',
    orderScanInRtmQty: 'RTM订单扫描入库条数',
    unOrderScanInRtmQty: '非RTM订单扫描入库条数',
    appFinishedSalesQty: 'e店通已完成售出条数',
    warrantyApprovedQty: 'e店通延保审核通过条数',
    warrantyToBeReviewedQty: 'e店通待审核条数',
    unWarrantyApprovedQty: 'e店通延保审核未通过条数'
  },
  storeonlineorderreport: {
    input: {
      retailerId: '客户编号',
      retailerName: '店名',
      orderNo: '订单号',
      tireOrderNo: '延保单号',
      orderCreateTime: '订单创建时间',
      finishedTime: '订单完成时间',
      dataHolder: '请选择日期',
      exportFailed: '导出失败'
    },
    exportFileName: '固特异e店通 by订单',
    exportSumFileName: '固特异e店通 by订单',
    retailerId: '客户编号',
    retailerName: '店名',
    orderNo: '订单号',
    tireOrderNo: '延保单号',
    orderCreateTime: '订单创建时间',
    finishedTime: '订单完成时间',
    orderLabel: '订单标签',
    warrantyScanOutQty: '订单扫码延保条数',
    orderScanInQty: '订单扫码入库条数',
    orderSkuQty: '订单轮胎数量'
  },
  fdpreport: {
    input: {
      dataHolder: '请选择日期',
      exportFailed: '导出失败',
      retailerId: '发货门店ID',
      retailerName: '发货门店名称',
      orderNo: '送货单号',
      createDate: '送货单创建时间',
      tireOrderNo: '延保单号',
      orderCreateTime: '订单创建时间',
      receivedTime: '收货时间'
    },
    exportFileName: 'fdp',
    exportSumFileName: 'fdp',
    table: {
      sku: 'SAP号码',
      b2bName: 'SAP名称',
      tireStatus: '轮胎状态',
      orderNo: '送货单号',
      orderType: '送货单类型',
      retailerId: '发货门店ID',
      retailerName: '发货门店名称',
      consigneeRetailerName: '到货客户名称',
      consigneeAddress: '到货地址',
      stockoutDistance: '发货围栏（确认发货-最近有效备案地址）',
      retailerStoreAddress: '距离最近有效发货地址',
      pickedupDistance: '提货围栏（确认发货-送货员确认提货）',
      photoDistance: '到货围栏（门头-到货地址）',
      deliveryDistance: '到货围栏（确认送达-到货地址',
      photoToDeliveryDistance: '门头-到货围栏（确认送达）',
      auditScore: '照片审核评分',
      auditRemark: '照片审核备注',
      deliveryDuration: '送达时效',
      overDueFlag: '是否超期胎',
      nickname: '送货员昵称',
      createDate: '送货单创建时间',
      stockoutTime: '发货时间',
      pickedupTime: '提货时间',
      deliveryTime: '到货时间',
      returnTime: '退货入库时间',
      receivedTime: '收货时间'
    }
  },
  extendedwarrantyresults: {
    input: {
      orderNumber: '延保单号',
      barCode: '条形码',
      qrcode: '二维码',
      status: '状态',
      ruleCodeList: '规则',
      retailerId: '客户编号',
      retailerName: '店名',
      createTime: '创建时间',
      dataHolder: '请选择日期',
      exportFailed: '导出失败',
      tireOrderRatingList: '照片审核评分',
      sku: 'SAP号码',
      sapDescription: '产品描述'
    },
    exportFileName: '延保审核结果',
    exportSumFileName: '延保审核结果',
    orderNumber: '延保单号',
    barCode: '条形码',
    qrcode: '二维码',
    status: '状态',
    tireOrderRating: '照片审核评分',
    rulesValueListStr: '规则',
    remark: '延保审核备注',
    lyTireSpecMatchingResult: '力洋视图匹配结果',
    warrantyExtensionReview: '延保复审结论',
    retailerId: '客户编号',
    retailerName: '店名',
    retailerAddress: '地址',
    tireItemNo: '行项目',
    sku: 'SAP号码',
    tirePosition: '轮胎位置',
    sapDescription: '产品描述',
    vin: '车辆识别号',
    licensePlate: '车牌信息',
    brandModule: '行驶证车型',
    tireOrderCreateTime: '延保单创建时间'
  },
  taskassignment: {
    BoxWrap: {
      manage: '任务分配',
      export: '导出',
      import: '导入'
    },
    common: {
      fileName: '任务分配',
      exportFailed: '导出失败'
    },
    input: {
      optionPlaceholder: '请选择',
      taskDescription: '任务分配描述',
      rsmEmpNo: 'RH工号',
      rsmEmpName: 'RH姓名',
      asmEmpNo: 'ASM工号',
      asmEmpName: 'ASM姓名',
      srEmpNo: 'SR工号',
      srEmpName: 'SR姓名',
      deadlineTime: '截止时间',
      dataHolder: '请选择日期'
    },
    table: {
      taskDescription: '任务分配描述(拜访目的)',
      allocatedType: '指派类型',
      deadlineTimeFormatted: '截止日期',
      rsmEmpNo: '被指派区域RH工号',
      rsmEmpName: '被指派区域RH姓名',
      asmEmpNo: '被指派ASM工号',
      asmEmpName: '被指派ASM姓名',
      srEmpNo: '被指派SR工号',
      srEmpName: '被指派SR姓名',
      rtlRtmCategory: 'RTM类型',
      retailerType: '零售店类别',
      spSapId: '服务商编号',
      spFullName: '服务商名称',
      rtlRegion: '省',
      rtlCity: '市',
      rtlSapId: '客户编号',
      rtlFullName: '店名',
      remark: '备注'
    }
  }
};